const censorWord = function (str) {
  return str[0] + '*'.repeat(str.length - 2) + str.slice(-1);
};

const censorEmail = function (email) {
  const arr = email.split('@');
  return censorWord(arr[0]) + '@' + arr[1];
};

const censorPhoneNumber = function (phoneNumber) {
  phoneNumber = phoneNumber.replace(/#|-()/g, '');
  return `***-***-${phoneNumber.substr(phoneNumber.length - 4, 4)}`;
};

export {
  censorEmail,
  censorPhoneNumber
};



// WEBPACK FOOTER //
// ./src/utils/censor.js